/*
 * @Date: 2022-06-30 14:33:07
 * @LastEditTime: 2022-09-02 16:34:58
 * @Description: file content
 * @FilePath: \traffic\src\apis\pc\guidance\guidance.js
 */
import api from '../../api-request'
// 开通获取开通参数
function getGuidanceParameter(params) {
  return api.get('/traffic/open/info', { params })
}
// 获取企业信息corpId
function getGuidanceMessage() {
  return api.get('/traffic/wx/config/info')
}
// 修改企业corpId
function UpdateGuidanceCorpId(id) {
  return api.get('/traffic/wx/config/wxOpenCorpId/set', {
    params: {
      wxOpenCorpId: id
    }
  })
}
// 修改企业配置信息
function getGuidanceEdit(params) {
  return api.post('/traffic/wx/config/edit', params)
}
// 企业是否可用
function getCompanyOpenInfo() {
  return api.get('/traffic/is/open')
}
// 企业消息存档是否可用
function getIsMessageOpen() {
  return api.get('/traffic/chatSession/isOpened')
}

// 是否授权第三方消息存档
function getThirdChatAuth() {
  const reallyOid = window?.current_org?.oid || window?.AppConf?.org?.oid || window.top?.current_org?.oid
  return api.get('/traffic/config/thirdChat/auth', {
    params: {
      oid: process.env.NODE_ENV === 'development' ? process.env?.OID : reallyOid
    }
  })
}
// 用户消息存档是否可用
function getIsMessageOpenByUser() {
  return api.get('/chat-session/session/isOpen')
}
// 自建应用是否购买
function getNoExpire() {
  return api.get('/traffic/wx/config/info/noExpire')
}
// 消息存档获取开通参数
function getMessageOpenParams() {
  return api.get('/traffic/chatSession/open/info')
}
// 修改消息存档配置信息
function getMessageEdit(params) {
  return api.post('/traffic/chatSession/config/edit', params)
}
// 修改企业配置信息
function updateCompanyInfo(params) {
  return api.post('/traffic/common/config/edit', params)
}

// 修改企业配置信息
function getGuidanceEditfive(params) {
  return api.post(`/traffic/abf/edit?abfSecret=${params.abfSecret}`)
}

// 新版企业配置信息获取二维码
function getQrCode(oid) {
  return api.get(`/traffic/wx/empower/get_customized/auth_url?oid=${oid}`)
}

// 新版企业配置信息授权状态
function getNextStatus() {
  return api.get(`/traffic/wx/empower/check/authorized`)
}

// 新版企业配置信息验证
function getSecretStatus(abfSecret) {
  return api.post(`/traffic/wx/empower/config/complete?abfSecret=${abfSecret}`)
}

// 新版企业配置信息绑定状态
function getIsBind() {
  return api.get(`/traffic/wx/empower/get/bindResult`)
}

// 新版企业配置信息通讯录是否可用
function getMailListEnable() {
  return api.get(`/traffic/wx/empower/check/abfEnable`)
}

// 新版企业配置信息立即体验权限是否开通
function getExperienceStatus() {
  return api.get(`/traffic/wx/empower/check/auth`)
}

// 清空已生效的会话存档配置信息
function clearSessionSetting() {
  return api.get('/chat-session/wx/csConfig/clear')
}

// 获取当前用户是否是企微超级管理员
function getQwSupperAdmin() {
  return api.get('/traffic/userIsAdmin/check')
}
// 获取会话存档授权二维码链接
function getThirdCode() {
  return api.get('/traffic/third/chat/auth')
}

export default {
  getGuidanceParameter,
  getGuidanceMessage,
  getGuidanceEdit,
  getCompanyOpenInfo,
  getMessageOpenParams,
  getIsMessageOpen,
  getMessageEdit,
  updateCompanyInfo,
  getGuidanceEditfive,
  getQrCode,
  getNextStatus,
  getSecretStatus,
  getIsBind,
  getMailListEnable,
  getExperienceStatus,
  getIsMessageOpenByUser,
  UpdateGuidanceCorpId,
  clearSessionSetting,
  getQwSupperAdmin,
  getThirdChatAuth,
  getThirdCode,
  getNoExpire,
}
